module.exports = __webpack_public_path__ + "static/media/Articles 10.60e0bfad.svg";